import type { Locale } from '@/shared/store/localeStore'

export type RouteId =
  | 'help-hub'
  | 'help-category:how-it-works'
  | 'help-category:reliability'
  | 'help-category:cancel-game'
  | 'help-category:ratings'
  | 'help-category:waitlist'
  | 'help-category:stores'
  | 'about'
  | 'terms'
  | 'privacy'

export const routePaths: Record<RouteId, { es: string; en: string }> = {
  'help-hub': { es: '/help', en: '/en/help' },
  'help-category:how-it-works': {
    es: '/help/como-funciona',
    en: '/en/help/how-it-works',
  },
  'help-category:reliability': {
    es: '/help/fiabilidad',
    en: '/en/help/reliability',
  },
  'help-category:cancel-game': {
    es: '/help/cancelar-partida',
    en: '/en/help/cancel-game',
  },
  'help-category:ratings': {
    es: '/help/valoraciones',
    en: '/en/help/ratings',
  },
  'help-category:waitlist': {
    es: '/help/lista-de-espera',
    en: '/en/help/waitlist',
  },
  'help-category:stores': {
    es: '/help/tiendas',
    en: '/en/help/stores',
  },
  about: { es: '/about', en: '/en/about' },
  terms: { es: '/terms', en: '/en/terms' },
  privacy: { es: '/privacy', en: '/en/privacy' },
}

export function getLocalizedPath(routeId: RouteId, locale: Locale): string {
  return routePaths[routeId][locale]
}

export function findRouteIdByPath(pathname: string): RouteId | null {
  const cleaned = pathname.split('?')[0]!.split('#')[0]!
  const normalized = cleaned.replace(/\/+$/, '') || cleaned
  for (const id of Object.keys(routePaths) as RouteId[]) {
    const { es, en } = routePaths[id]
    if (normalized === es || normalized === en) return id
  }
  return null
}
